import React, { memo } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LoadingButton
} from 'investira.react.components';

const AvaliacoesGestorAnexoRemocaoDialog = memo(props => {
  const { anexo, onClose, onConfirm } = props;

  return (
    <Dialog open={Boolean(anexo)} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Confirmar exclusão do anexo</DialogTitle>
      <DialogContent>
        <DialogContentText variant="body2">
          Tem certeza que deseja remover o anexo <b>{anexo?.nome || anexo?.arquivo || 'selecionado'}</b>?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton variant="text" data-testid="cancelar-remocao-anexo" onClick={onClose}>
          Cancelar
        </LoadingButton>
        <LoadingButton
          variant="contained"
          color="error"
          data-testid="confirmar-remocao-anexo"
          onClick={onConfirm}>
          Excluir
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
});

export default AvaliacoesGestorAnexoRemocaoDialog;
